import { render } from "./EdificiDataTable.vue?vue&type=template&id=7d7b2cb0"
import script from "./EdificiDataTable.vue?vue&type=script&lang=js"
export * from "./EdificiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__